module.exports = __webpack_public_path__ + "img/syllabus_imge3.fa9a43be.png";